import { Component, ViewEncapsulation } from '@angular/core';
import { ModalInjectableData } from '@rogers/cdk/common/classes';
import { ModalRef } from '@rogers/cdk/modal';
import { UserAccount } from '@rogers/self-serve-common/account';

@Component({
  selector: 'fss-account-selector-modal',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./account-selector-modal.component.scss'],
  templateUrl: './account-selector-modal.component.html',
})
export class AccountSelectorModalComponent {
  readonly accounts: UserAccount[];

  constructor(
    modalData: ModalInjectableData,
    private readonly modalRef: ModalRef,
  ) {
    this.accounts = modalData.source.accounts;
  }

  selectAccount(selectedAccountNumber: string) {
    this.modalRef.close(selectedAccountNumber);
  }
}
